import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { PathItem } from './../builders/path_item_builder';
import { PathTask } from './../builders/path_task_builder';
import { PathTopic } from './../builders/path_topic_builder';

angular
  .module('data-ng-todos')
  .factory(
    'clearPathDatastoresCommand',
    function clearPathDatastoresCommandDefinition(
      defineCommand: IDefineCommand,
      ngPathItemDatastore: IDatasource<PathItem>,
      ngPathTopicDatastore: IDatasource<PathTopic>,
      ngPathTaskDatastore: IDatasource<PathTask>,
      ngOverduePathTaskDatastore: IDatasource<PathTask>
    ): void {
      return defineCommand(
        'clearPathDatastoresCommand',
        function clearPathDatastoresCommand(deferred: ng.IDeferred<any>): any {
          ngPathItemDatastore.clear();
          ngPathTopicDatastore.clear();
          ngPathTaskDatastore.clear();
          ngOverduePathTaskDatastore.clear();
          ORM.run();
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/clear_path_datastores_command.ts